module.exports = __webpack_public_path__ + "build/assets/FiraMath-Regular-5c59fb12d792b0d02b05ed7b22caba3b.woff2";